module.exports = __webpack_public_path__ + "img/news.19c550f1.jpg";